export class LlgLocationWithResources {
    'locationResource';
    'logSources';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "locationResource",
            "baseName": "locationResource",
            "type": "LlgLocationResource",
            "format": ""
        },
        {
            "name": "logSources",
            "baseName": "logSources",
            "type": "Array<LogSourceWithPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return LlgLocationWithResources.attributeTypeMap;
    }
    constructor() {
    }
}
